import type {Placement} from '@popperjs/core';
import React, {FC, RefObject} from 'react';

import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {MacrosBaseModel} from '../../../../models/api/macroModel';
import {PermissionsEnum} from '../../../../models/api/roleModel';
import {getHasPermission} from '../../../../store/data/access/accessSelectors';
import {MacroPreviewDropdown} from './macroPreviewDropdown';
import {TriggerPreview} from './triggerPreview';

interface MacroPreviewProps {
  anchor: RefObject<HTMLElement>;
  popperPlacement: Placement;
  macro: MacrosBaseModel;
}

export const MacroPreview: FC<MacroPreviewProps> = ({anchor, popperPlacement, macro}) => {
  const hasPermission = useAppSelector(getHasPermission);
  const canEditMacro = hasPermission(macro.namespace, PermissionsEnum.RULE_UPDATE);
  const dropdownRenderer = canEditMacro
    ? (menuRef: RefObject<HTMLDivElement>, onDismiss: () => void) => (
        <MacroPreviewDropdown anchor={menuRef} placement="bottom-end" onClose={onDismiss} macro={macro} />
      )
    : undefined;
  return (
    <TriggerPreview
      anchor={anchor}
      popperPlacement={popperPlacement}
      header={macro.name}
      content={macro.description}
      optionsDropdownRenderer={dropdownRenderer}
    />
  );
};
